import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";

export function DeleteDogDialog({
  open,
  dogName,
  onClose,
  onConfirm,
}: {
  open: boolean;
  dogName: string;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(135deg, #FFE5E2 0%, #FFF5F3 100%)",
          pt: { xs: 2.5, sm: 3 },
          pb: { xs: 1.5, sm: 2 },
          px: { xs: 2, sm: 3 },
          textAlign: "center",
        }}
      >
        <Typography sx={{ fontSize: { xs: 40, sm: 48 }, mb: 0.5 }}>👋</Typography>
        <Typography
          sx={{
            fontSize: { xs: 18, sm: 22 },
            fontWeight: 800,
            color: QUIZ.color.brown,
          }}
        >
          Say goodbye to {dogName}?
        </Typography>
      </Box>
      <DialogContent sx={{ pt: { xs: 2, sm: 2.5 }, pb: 1, px: { xs: 2, sm: 3 } }}>
        <Typography
          sx={{
            fontSize: { xs: 13, sm: 14 },
            color: QUIZ.color.brown,
            lineHeight: 1.6,
            textAlign: "center",
          }}
        >
          Don't worry — {dogName}'s profile will be safely stored. If you change your mind, you can always bring them back!
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2, sm: 3 },
          pb: { xs: 2, sm: 3 },
          gap: { xs: 1, sm: 1.5 },
          justifyContent: "center",
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          fullWidth
          sx={{
            py: { xs: 1, sm: 1.25 },
            borderRadius: "12px",
            color: QUIZ.color.brown,
            borderColor: "#E0D6CC",
            fontWeight: 700,
            fontSize: { xs: 13, sm: 14 },
            textTransform: "none",
            order: { xs: 2, sm: 1 },
            "&:hover": {
              borderColor: QUIZ.color.brown,
              backgroundColor: "#F8F4EF",
            },
          }}
        >
          Keep {dogName}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          fullWidth
          sx={{
            py: { xs: 1, sm: 1.25 },
            borderRadius: "12px",
            backgroundColor: "#D14C3F",
            fontWeight: 700,
            fontSize: { xs: 13, sm: 14 },
            textTransform: "none",
            order: { xs: 1, sm: 2 },
            "&:hover": { backgroundColor: "#B7372B" },
          }}
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
